var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 11,
  viewBox: "0 0 19 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m6.384 1.225-3.99 3.99h15.314a.43.43 0 0 1 .437.437.43.43 0 0 1-.437.437H2.394l3.99 3.99c.209.21.209.4 0 .608a.4.4 0 0 1-.304.133.4.4 0 0 1-.304-.133l-4.731-4.73c-.21-.21-.21-.4 0-.609l4.73-4.73c.4-.419 1.008.19.609.607"
})));
export { SvgArrowLeft as ReactComponent };